<template>
    <div id="reportContainer" ref="reportContainer">
        <p class="text-capitalize font-weight-bold m-0 pt-0 mt-3">Sales Report</p>
        <b-overlay :show="isBusy" rounded="sm" >
        <p class="text-capitalize">{{ reqData.msg }}</p>
            <div class="row" v-if="dataSalesReport">
                <div class="col-12 d-none d-md-block">
                    <b-table-simple bordered hover small responsive striped>
                        <b-thead head-variant="none">
                            <b-tr>
                                <b-th rowspan="2">Date</b-th>
                                <b-th colspan="4">Sales</b-th>
                                <b-th colspan="2">Sales Data - Avg/Order</b-th>
                                <b-th colspan="3">Collections</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th>#Orders</b-th>
                                <b-th>#Items</b-th>
                                <b-th>Gross Sales</b-th>
                                <b-th>Crdit/Rfnd</b-th>
                                <b-th>$Sale</b-th>
                                <b-th>#Items</b-th>
                                <b-th>Tax</b-th>
                                <b-th>Tax2</b-th>
                                <b-th>Tip</b-th>                            
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item) in dataSalesReport.rows" :key="item.date">
                                <b-td>{{moment(item.date).format("MM/DD/YY")}}</b-td>
                                <b-td>{{item.orders}}</b-td>                          
                                <b-td>{{item.items}}</b-td>                          
                                <b-td>{{$c2d(item.grossSales) | currency}}</b-td>
                                <b-td>{{$c2d(item.refunds) | currency}}</b-td>                          
                                <b-td>{{$c2d(item.averageSales) | currency}}</b-td> 
                                <b-td>{{item.averageItems | decimalNumber(2)}}</b-td>
                                <b-td>{{$c2d(item.tax) | currency}}</b-td>
                                <b-td>{{$c2d(item.tax2) | currency}}</b-td>                                
                                <b-td>{{$c2d(item.tips) | currency}}</b-td> 
                            </b-tr>                      
                        </b-tbody>
                        <b-tfoot foot-variant="none">
                            <b-tr>
                                <b-td colspan="2"><br/></b-td>
                                <b-td colspan="4"></b-td>
                                <b-td colspan="2"></b-td>
                                <b-td colspan="3"></b-td>
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.totals">
                                <b-th>Total</b-th>
                                <b-th>{{item.orders}}</b-th>                          
                                <b-th>{{item.items}}</b-th>                          
                                <b-th>{{$c2d(item.grossSales) | currency}}</b-th>
                                <b-th>{{$c2d(item.refunds) | currency}}</b-th>                          
                                <b-th>{{$c2d(item.averageSales) | currency}}</b-th> 
                                <b-th>{{item.averageItems | decimalNumber(2)}}</b-th>
                                <b-th>{{$c2d(item.tax) | currency}}</b-th>
                                <b-th>{{$c2d(item.tax2) | currency}}</b-th>
                                <b-th>{{$c2d(item.tips) | currency}}</b-th>                             
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.averages">
                                <b-th>Average</b-th>
                                <b-th>{{item.orders}}</b-th>                          
                                <b-th>{{item.items}}</b-th>                          
                                <b-th>{{$c2d(item.grossSales) | currency}}</b-th>
                                <b-th>{{$c2d(item.refunds) | currency}}</b-th>                          
                                <b-th>{{$c2d(item.averageSales) | currency}}</b-th> 
                                <b-th>{{item.averageItems | decimalNumber(2)}}</b-th>
                                <b-th>{{$c2d(item.tax) | currency}}</b-th>
                                <b-th>{{$c2d(item.tax2) | currency}}</b-th>
                                <b-th>{{$c2d(item.tips) | currency}}</b-th>                           
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </div>
                <div class="col-12 d-block d-md-none">
                    <b-table-simple bordered hover small responsive striped>
                        <b-thead head-variant="none">
                            <b-tr>                                
                                <b-th colspan="5">Sales</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th>Date</b-th>
                                <b-th>#Orders</b-th>
                                <b-th>#Items</b-th>
                                <b-th>GS</b-th>
                                <b-th>CR</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item) in dataSalesReport.rows" :key="item.date">
                                <b-td>{{moment(item.date).format("MM/DD/YY")}}</b-td>
                                <b-td>{{item.orders}}</b-td>                          
                                <b-td>{{item.items}}</b-td>                          
                                <b-td>{{$c2d(item.grossSales) | currency}}</b-td>
                                <b-td>{{$c2d(item.refunds) | currency}}</b-td>                          
                            </b-tr>                      
                        </b-tbody>
                        <b-tfoot foot-variant="none">
                            <b-tr>
                                <b-td colspan="2"><br/></b-td>
                                <b-td colspan="4"></b-td>
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.totals">
                                <b-th>Total</b-th>
                                <b-th>{{item.orders}}</b-th>                          
                                <b-th>{{item.items}}</b-th>                          
                                <b-th>{{$c2d(item.grossSales) | currency}}</b-th>
                                <b-th>{{$c2d(item.refunds) | currency}}</b-th>                          
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.averages">
                                <b-th>Average</b-th>
                                <b-th>{{item.orders}}</b-th>                          
                                <b-th>{{item.items}}</b-th>                          
                                <b-th>{{$c2d(item.grossSales) | currency}}</b-th>
                                <b-th>{{$c2d(item.refunds) | currency}}</b-th>                          
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </div>
                <div class="col-12 d-block d-md-none">
                    <b-table-simple bordered hover small responsive striped>
                        <b-thead head-variant="none">
                            <b-tr>
                                <b-th colspan="3">Sales Data - Avg/Order</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th>Date</b-th>                                
                                <b-th>$Sale</b-th>
                                <b-th>#Items</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item) in dataSalesReport.rows" :key="item.date">
                                <b-td>{{moment(item.date).format("MM/DD/YY")}}</b-td>
                                <b-td>{{$c2d(item.averageSales) | currency}}</b-td> 
                                <b-td>{{item.averageItems | decimalNumber(2)}}</b-td> 
                            </b-tr>                      
                        </b-tbody>
                        <b-tfoot foot-variant="none">
                            <b-tr>
                                <b-td colspan="2"><br/></b-td>
                                <b-td colspan="2"></b-td>
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.totals">
                                <b-th>Total</b-th>
                                <b-th>{{$c2d(item.averageSales) | currency}}</b-th> 
                                <b-th>{{item.averageItems | decimalNumber(2)}}</b-th>
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.averages">
                                <b-th>Average</b-th>                    
                                <b-th>{{$c2d(item.averageSales) | currency}}</b-th> 
                                <b-th>{{item.averageItems | decimalNumber(2)}}</b-th>
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </div>
                <div class="col-12 d-block d-md-none">
                    <b-table-simple bordered hover small responsive striped>
                        <b-thead head-variant="none">
                            <b-tr>                                
                                <b-th colspan="4">Collections</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th>Date</b-th>
                                <b-th>Tax</b-th>
                                <b-th>Tax2</b-th>
                                <b-th>Tip</b-th>                            
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item) in dataSalesReport.rows" :key="item.date">
                                <b-td>{{moment(item.date).format("MM/DD/YY")}}</b-td>
                                <b-td>{{$c2d(item.tax) | currency}}</b-td>
                                <b-td>{{$c2d(item.tax2) | currency}}</b-td>                                
                                <b-td>{{$c2d(item.tips) | currency}}</b-td> 
                            </b-tr>                      
                        </b-tbody>
                        <b-tfoot foot-variant="none">
                            <b-tr>
                                <b-td colspan="2"><br/></b-td>
                                <b-td colspan="3"></b-td>
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.totals">
                                <b-th>Total</b-th>
                                <b-th>{{$c2d(item.tax) | currency}}</b-th>
                                <b-th>{{$c2d(item.tax2) | currency}}</b-th>
                                <b-th>{{$c2d(item.tips) | currency}}</b-th>                             
                            </b-tr>
                            <b-tr v-bind="item = dataSalesReport.averages">
                                <b-th>Average</b-th>
                                <b-th>{{$c2d(item.tax) | currency}}</b-th>
                                <b-th>{{$c2d(item.tax2) | currency}}</b-th>
                                <b-th>{{$c2d(item.tips) | currency}}</b-th>                           
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </div>
            </div>
            <span class="text-danger">{{msgError}}</span>
        </b-overlay>                
    </div>
</template>
<script>
export default {
    props:{
        reqData : {type: Object}
    },
    data(){
        return {
           msgError : "", 
           isBusy : false,
           dataSalesReport : null
        }
    },
    watch:{
        reqData : {
            deep: true,
            immediate: true,            
            handler() {
                this.salesReport()
            }
		}
    },
    computed:{
    },
    methods:{        
        salesReport() {
            this.msgError = ""
            this.dataSalesReport = null
            this.isBusy = true
            this.$store.dispatch('apiSalesReport', this.reqData)
                .then(_res => {
                    this.isBusy = false
                    if(_res.status){
                        this.dataSalesReport = _res.res
                    }
                }).catch((e)=>{
                    this.msgError = e.msgError;
                    this.isBusy = false
                })
        }        
    },
    mounted(){
        this.salesReport()
    }    
}
</script>